import React, { useState } from 'react';
import { Lock, Key } from 'lucide-react';
import { ErrorModal } from '../shared/ErrorModal';

export const PasscodeView = ({ onVerify, onLogout }) => {
    const [passcode, setPasscode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // The onVerify function will be passed from the parent and will contain the logic
        // to check the passcode against the environment variable.
        const isCorrect = onVerify(passcode);

        if (!isCorrect) {
            setError('Incorrect passcode. Please try again.');
            setPasscode('');
        }
        // If it's correct, the parent component will handle navigation.
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-slate-900">
            <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
            <div className="w-full max-w-sm text-center">
                <div className="bg-purple-500/20 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 border-2 border-purple-500">
                    <Lock className="w-10 h-10 text-purple-400" />
                </div>
                <h1 className="text-3xl font-bold text-white mb-2">Access Required</h1>
                <p className="text-slate-400 mb-8">Please enter the passcode to continue.</p>

                <form onSubmit={handleSubmit} className="bg-slate-800/50 rounded-xl p-6 space-y-4 border border-slate-700">
                    <div>
                        <label htmlFor="passcode" className="sr-only">Passcode</label>
                        <div className="relative">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <Key className="h-5 w-5 text-slate-400" />
                            </div>
                            <input
                                type="password"
                                id="passcode"
                                value={passcode}
                                onChange={(e) => setPasscode(e.target.value)}
                                className="w-full pl-10 pr-3 py-2.5 rounded-lg bg-slate-700 border border-slate-600 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-purple-400"
                                placeholder="Enter passcode"
                                required
                            />
                        </div>
                    </div>
                    <button type="submit" disabled={loading} className="w-full bg-purple-600 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition-all disabled:opacity-50 disabled:cursor-wait">
                        {loading ? 'Verifying...' : 'Unlock'}
                    </button>
                </form>
                 <button onClick={onLogout} className="text-sm text-slate-500 hover:text-white mt-6">
                    Log Out
                </button>
            </div>
        </div>
    );
};